/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';

import LoadingIndicator from '/component/base/LoadingIndicator';

import {styles} from './FirstWeek.style';
import {FirstWeekTasks} from './FirstWeekTasks';
interface FirstWeekProps {
  clientId?: number | null;
  hasFirstWeekTasks?: boolean;
  orderId?: number | null;
  hasFirstOrder?: boolean;
  onShowTaskDetail?: () => void;
  clientJourneyTimer?: number;
}

export const FirstWeek: React.FC<FirstWeekProps> = ({
  clientId = null,
  hasFirstWeekTasks = false,
  orderId = null,
  hasFirstOrder = false,
  onShowTaskDetail = () => {},
  clientJourneyTimer = 6000,
}) => {
  const hasTasks = orderId
    ? hasFirstWeekTasks && hasFirstOrder
    : hasFirstWeekTasks;

  return (
    <View style={styles.base}>
      {hasTasks ? (
        <FirstWeekTasks
          clientId={clientId}
          onShowTaskDetail={onShowTaskDetail}
          clientJourneyTimer={clientJourneyTimer}
          orderId={orderId}
        />
      ) : (
        <LoadingIndicator style={styles.loader} />
      )}
    </View>
  );
};
